/////////////////////////////////////////////////////////////////////////////////////////////////////////
// 화일명 : gridRMenuUtil.ts
// 설명   : AgGrid 우클릭메뉴 [레퍼런스팝업 열기] - 컬럼(field)별 매핑(ZA_GRID_RMENU) 지연로딩+캐싱
//         - 우클릭 메뉴는 즉시 떠야 하는 UI라서, 앱 시작 시 미리 불러오지 않고 "첫 우클릭 시 1회만"
//           서버에서 조회한 뒤 모듈 전역 Promise에 캐싱해서 이후에는 재조회 없이 재사용함.
//         - 조회 실패 시에는 캐시를 비워서 다음 우클릭 때 재시도할 수 있게 함.
/////////////////////////////////////////////////////////////////////////////////////////////////////////
import axios from 'axios';
import { API_BASE_URL } from '../config';

export interface GridRMenuRow {
  menuId: string; // 2026-09-18: ZA_GRID_RMENU.PGM_ID -> MENU_ID 컬럼명 변경에 맞춰 필드명도 함께 변경
  objId: string;
  popupUrl: string;
  paramKey: string;
  titleKey?: string;
}

let cachePromise: Promise<GridRMenuRow[]> | null = null;

export function loadGridRMenu(): Promise<GridRMenuRow[]> {
  if (!cachePromise) {
    cachePromise = axios.post(`${API_BASE_URL}/com/apiGridRMenu`, {})
      .then(res => {
        const rows = res?.data?.rsResults;
        return Array.isArray(rows) ? rows.map((r: any) => ({
          menuId: r.MENU_ID,
          objId: r.OBJ_ID,
          popupUrl: r.POPUP_URL,
          paramKey: r.PARAM_KEY || r.OBJ_ID,
          titleKey: r.TITLE_KEY,
        })) : [];
      })
      .catch(() => {
        cachePromise = null; // 실패 시 캐시를 비워서 다음 우클릭에 재시도 가능하게 함
        return [];
      });
  }
  return cachePromise;
}

// PARAM_KEY 해석: "a,b" 또는 "팝업파라미터=그리드컬럼" 형식(쉼표 구분). 비어 있으면 OBJ_ID 하나로 봄.
export function parseParamPairs(paramKey: string, objId: string): { param: string; field: string }[] {
  return (paramKey || objId).split(',').map(s => s.trim()).filter(Boolean).map(item => {
    const [param, field] = item.includes('=') ? item.split('=').map(s => s.trim()) : [item, item];
    return { param, field };
  });
}

// menuId(화면 전용 오버라이드) 우선 매칭 -> 없으면 전역('*') 매칭
//  - 참고: 여기 넘어오는 값은 AgGrid.tsx가 받은 menuId(ZA_MENU.MENU_ID), 없으면 callPgmId에서 뽑은 화면ID임.
export function findGridRMenu(rows: GridRMenuRow[], menuId: string | undefined, field: string | undefined): GridRMenuRow | undefined {
  if (!field) return undefined;
  return rows.find(r => r.menuId === menuId && r.objId === field)
      ?? rows.find(r => r.menuId === '*' && r.objId === field);
}
